import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { demoTrueAsync ,resetState as resetTrueState } from '../features/demo/demoTrue/demoTrueSlice';
import { demoDareAsync, resetState as resetDareState, selectDemoDare } from '../features/demo/demoDare/demoDareSlice';
import { demoLightDareAsync, resetState as resetLightDareState } from '../features/demo/demoLightDare/demoLightDareSlice';
import TruthOrDareCard from '../components/TruthOrDareCard';
import QuestionCard from '../components/QuestionCard';
import {
  incrementPlayerOneDemoDaresAnswered, incrementPlayerOneDemoLightDaresAnswered, incrementPlayerOneDemoShotsTaken, incrementPlayerOneDemoTruthsAnswered,
  incrementPlayerTwoDemoDaresAnswered, incrementPlayerTwoDemoLightDaresAnswered, incrementPlayerTwoDemoShotsTaken, incrementPlayerTwoDemoTruthsAnswered, resetGame as resetContestantSlice, toggleDemoPlayerTurn
} from '../features/contestants/contestantsSlice';
import { useNavigate } from 'react-router-dom';
import MenuButton from '../components/MenuButton';
import { setGameReset } from '../features/gamesStatus/gameStatusSlice';
import PopoverCard from '../components/PopoverCard';
import { submitCardInteractionAsync } from '../features/cardInteraction/cardInteractionSlice';
import { recordShots } from '../features/gamesStatus/gameSessionApi';


const DemoGame = () => {
  const playerOne = useSelector((state) => state.contestants.playerOne);
  const playerTwo = useSelector((state) => state.contestants.playerTwo);
  const gameMode = useSelector((state) => state.contestants.gameMode);
  const currentPlayer = useSelector((state) => state.contestants.demoPlayerTurn === "playerOne" ? state.contestants.playerOne : state.contestants.playerTwo)
  const currentPlayerTruthsAnswered = useSelector((state) => state.contestants.demoPlayerTurn === "playerOne" ? state.contestants.playerOne.demoTruthsAnswered : state.contestants.playerTwo.demoTruthsAnswered)
  const currentPlayerLightDaresAnswered = useSelector((state) => state.contestants.demoPlayerTurn === "playerOne" ? state.contestants.playerOne.demoLightDaresAnswered : state.contestants.playerTwo.demoLightDaresAnswered)
  const currentPlayerDaresAnswered = useSelector((state) => state.contestants.demoPlayerTurn === "playerOne" ? state.contestants.playerOne.demoDaresAnswered : state.contestants.playerTwo.demoDaresAnswered)
  const currentPlayerShotsTaken = useSelector((state) => state.contestants.demoPlayerTurn === "playerOne" ? state.contestants.playerOne.demoShotsTaken : state.contestants.playerTwo.demoShotsTaken)
  const sessionId = useSelector((state) => state.gameStatus?.sessions?.demo?.sessionId);
  const demoTrue = useSelector((state) => state.demoTrue)
  const demoLightDare = useSelector((state) => state.demoLightDare)
  const demoDare = useSelector((state) => state.demoDare)
  const [cardSwitch, setCardSwitch] = useState(true)
  const [truthOrDare, setTruthOrDare] = useState("")
  const [question, setQuestion] = useState("")
  const [questionTimer, setQuestionTimer] = useState("")
  const [drinkQuestion, setDrinkQuestion] = useState("")
  const [attributes, setAttributes] = useState([])
  const [errorPopoverOpen, setErrorPopoverOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [buttonOneText, setButtonOneText] = useState('');
  const [onButtonOne, setOnButtonOne] = useState('');
  const [showButtonOne, setShowButtonOne] = useState(false);
  const gameType = 'demo'

  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    setQuestion(demoTrue.NewQuestion)
    setQuestionTimer(demoTrue.NewQuestionTimer)
    setDrinkQuestion(demoTrue.DrinkQuestion)
    setAttributes(demoDare.Attributes)
  }, [demoTrue.NewQuestion])
  
  useEffect(() => {
    setQuestion(demoLightDare.NewQuestion)
    setQuestionTimer(demoLightDare.NewQuestionTimer)
    setDrinkQuestion(demoLightDare.DrinkQuestion)
    setAttributes(demoDare.Attributes)
  }, [demoLightDare.NewQuestion])
  
  useEffect(() => {
    setQuestion(demoDare.NewQuestion)
    setQuestionTimer(demoDare.NewQuestionTimer)
    setDrinkQuestion(demoDare.DrinkQuestion)
    setAttributes(demoDare.Attributes)
  }, [demoDare.NewQuestion])

  const handleError = (error) => {
    if (error) {
        if (error.status === 403) {
            setErrorMessage('To use this feature, you need to purchase premium.');
            setButtonOneText('Go to Payment Page');
            setShowButtonOne(true);
            setOnButtonOne(() =>()=> navigate("/account/paymentpage"))
        } else if (error.status === 401) {
            setErrorMessage('You are not logged in.');
            setButtonOneText('Log In');
            setShowButtonOne(true);
            setOnButtonOne(() =>()=> navigate("/account/login"))
        } else if (error.status === 404) {
            setErrorMessage('For some reason we couldnt find another card for you, it might be a problem on our side, or youve finished all the cards for this deck!');
            setButtonOneText('Try again');
            setQuestion("For some reason we couldnt find another card for you, it might be a problem on our side, or youve finished all the cards for this deck!")
            setShowButtonOne(true);
            setOnButtonOne(() =>()=> setErrorPopoverOpen(false))
        }else {
            setErrorMessage('An unexpected error occurred.');
        }
    } else {
        setErrorMessage('An unexpected error occurred.');
    }
    setErrorPopoverOpen(true);
};

const handleClosePopover = () => {
  setErrorPopoverOpen(false);
};

  const DemoTrue = async () => {
    try {
      await dispatch(demoTrueAsync({ gender: currentPlayer.gender, player: currentPlayer.id })).unwrap()
      setTruthOrDare('Truth')
      toggleCardswitch()
    } catch (error) {
      console.error('Caught error in DemoTrue:', error);
      handleError(error); // ✅ Correctly handles popover
    }
    // setQuestion((state) => state.demoTrue.NewQuestion)

  }

  const DemoLightDare = async () => {
    try {
      await dispatch(demoLightDareAsync({ gender: currentPlayer.gender, player: currentPlayer.id })).unwrap()
      setTruthOrDare('Light Dare')
      toggleCardswitch()
    } catch (error) {
      console.error('Caught error in DemoLightDare:', error);
      handleError(error); // ✅ Correctly handles popover
    } 
    // setQuestion((state) => state.demoLightDare.NewQuestion)
  }

  const DemoDare = async () => {
    try {
      await dispatch(demoDareAsync({ gender: currentPlayer.gender, player: currentPlayer.id })).unwrap(); // ✅ `.unwrap()` ensures rejections are thrown
      setTruthOrDare('Dare');
      toggleCardswitch()
    } catch (error) {
      console.error('Caught error in DemoDare:', error);
      handleError(error); // ✅ Correctly handles popover
    }
    // setQuestion((state) => state.demoDare.NewQuestion)
  }

  const toggleParticipantsSwitch = () => {
    dispatch(toggleDemoPlayerTurn())
  };
  const addshots = () => {
    if (currentPlayer == playerOne) {
      dispatch(incrementPlayerOneDemoShotsTaken())
    } else { dispatch(incrementPlayerTwoDemoShotsTaken()) }
  }

  const bothDrink = () => {
    dispatch(incrementPlayerOneDemoShotsTaken())
    dispatch(incrementPlayerTwoDemoShotsTaken())
    toggleParticipantsSwitch()
    if (sessionId) recordShots({ sessionId, playerOneShot: true, playerTwoShot: true });
  }

  const addAsnweredQuestionCount = () => {
    if (currentPlayer == playerOne) {
      if (truthOrDare === "Light Dare") {
        dispatch(incrementPlayerOneDemoLightDaresAnswered())
      } else if (truthOrDare === "Truth") {
        dispatch(incrementPlayerOneDemoTruthsAnswered())
      } else {
        dispatch(incrementPlayerOneDemoDaresAnswered())
      }
    } else {
      if (truthOrDare === "Light Dare") {
        dispatch(incrementPlayerTwoDemoLightDaresAnswered())
      } else if (truthOrDare === "Truth") {
        dispatch(incrementPlayerTwoDemoTruthsAnswered())
      } else {
        dispatch(incrementPlayerTwoDemoDaresAnswered())
      }
    }
  }

  const swapTurns = () => {
    addAsnweredQuestionCount()
    toggleParticipantsSwitch()
    toggleCardswitch()
    dispatch(submitCardInteractionAsync({
          gameType: 'demo',           // could be 'explore', 'open', etc.
          type_of_card: truthOrDare,
          player: currentPlayer.id,
          skipped: false
          }));
    setQuestion("")
  }
  const swapTurnsAndAddShot = () => {
    addshots()
    toggleParticipantsSwitch()
    toggleCardswitch()
    dispatch(submitCardInteractionAsync({
      gameType: 'demo',
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: true,
      stopped_by: currentPlayer.id,
      shot_player: currentPlayer.id,
      }));
    setQuestion("")
  }
  const swapSkippedTurns = (stoppedById = currentPlayer.id) => {
    toggleParticipantsSwitch()
    toggleCardswitch()
    dispatch(submitCardInteractionAsync({
      gameType: 'demo',
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: true,
      stopped_by: stoppedById,
      }));
    setQuestion("")
  }
  const setPlayerAddShotAndSwap = (participant) => {
    const cardWasSkipped = participant === currentPlayer

    dispatch(submitCardInteractionAsync({
      gameType: 'demo',
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: cardWasSkipped,
      stopped_by: cardWasSkipped ? participant.id : null,
      shot_player: participant.id,
    }))

    addAsnweredQuestionCount()

    if (participant === playerTwo) {
      dispatch(incrementPlayerTwoDemoShotsTaken())
    } else {
      dispatch(incrementPlayerOneDemoShotsTaken())
    }

    toggleParticipantsSwitch()
    toggleCardswitch()
    setQuestion("")
  }

  const toggleCardswitch = () => {
    setCardSwitch(!cardSwitch);
  };
  const restartGame = () =>{
    dispatch(resetContestantSlice(gameType))
    dispatch(resetDareState())
    dispatch(resetLightDareState())
    dispatch(resetTrueState())
    setCardSwitch(true)
  }
  const onQuitWithoutSave = () => {
    restartGame()
    dispatch(setGameReset(gameType))
    navigate("/chooselevel")
  }
  const onSaveAndQuit = () => {
    navigate("/chooselevel")
  }
  const onSaveAndDownload = () => {
    navigate("/download")
  }
  const onDiscardAndDownload = () => {
    restartGame()
    dispatch(setGameReset(gameType))
    navigate("/download")
  }
  return (
    <div>
      <MenuButton
        showRestart={true}
        showChangeAccessories={true}
        showQuitGame={true}
        showSwitchGameMode={true}
        showDownload={true}
        onRestartClick={restartGame}
        onQuitGameClick={onQuitWithoutSave}
        onSaveAndQuit={onSaveAndQuit}
        onSaveAndDownload={onSaveAndDownload}
        onDiscardAndDownload={onDiscardAndDownload}
        gameType={gameType}
      />
      <PopoverCard
      mainText={errorMessage}
      open={errorPopoverOpen}
      onClose={()=>navigate('/')}
      showButtonOne={showButtonOne}
      textButtonOne={buttonOneText}
      onButtonOne={onButtonOne}
      />
      {cardSwitch ? <TruthOrDareCard
        fetchDare={DemoDare}
        fetchLightDare={DemoLightDare}
        fetchTruth={DemoTrue}
        playerOne={playerOne}
        playerTwo={playerTwo}
        currentPlayer={currentPlayer}
        currentPlayerTruthsAnswered={currentPlayerTruthsAnswered}
        currentPlayerLightDaresAnswered={currentPlayerLightDaresAnswered}
        currentPlayerDaresAnswered={currentPlayerDaresAnswered}
        currentPlayerShotsTaken={currentPlayerShotsTaken}
        gameType={gameType}
        bothDrink={bothDrink}
        lastTrue={demoTrue.LastCard}
        lastLight={demoLightDare.LastCard}
        lastDare={demoDare.LastCard}
      />
        :
        <QuestionCard
          question={question}
          questionTimer={questionTimer}
          drinkQuestion={drinkQuestion}
          attributes={attributes}
          swapTurns={swapTurns}
          swapTurnsAndAddShot={swapTurnsAndAddShot}
          swapSkippedTurns={swapSkippedTurns}
          truthOrDare={truthOrDare}
          currentPlayer={currentPlayer}
          playerOne={playerOne}
          playerTwo={playerTwo}
          setPlayerAddShotAndSwap={setPlayerAddShotAndSwap}
        />}
    </div>
  )
}

export default DemoGame
